module.exports = __webpack_public_path__ + "static/media/tiger_dice.30dcbae1.png";